<template>
  <div class="oss-more">
            <div>
            <el-button type='text'><slot name="button-name"></slot></el-button>
        </div>
        <el-dialog
        title="上传"
        :visible.sync="visible"
        width="50%"
        :before-close='beforeColse'>
           <slot name="tips"></slot>
           <el-row>
               <el-col :span="21">
                   <el-button type='primary' class="btn-select" @click="onChooseFile">选择文件</el-button>
                    <el-upload
                        class='upload-demo'
                        ref="upload"
                        action=''
                        :on-remove='handleRemove'
                        :on-change='onchange'
                        :limit='10'
                        :file-list='fileList'
                        :show-file-list='true'
                        :auto-upload='false'
                        >
                    </el-upload>
                </el-col>
                <el-col :span="3">
                  <div class="btn">
                    <el-button type='primary' class="btn-select" @click="submitUpload" :loading='loading'>保 存</el-button>
                    </div>
                </el-col>
           </el-row>
        </el-dialog>
  </div>
</template>
<script>
import Uploader from './uploader.js';
import { OSS_FILE_MAX_SIZE } from '../../constant/constant.js'

const THOUSAND_TWENTY_FOUR = 1024;

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fileList: [],
            loading: false,
            successNum: 0,
            ossFileList: []
        };
    },
    mounted() {
        this.uploader = new Uploader({ multiple: false, autoUpload: false })
            .on('change', (a) => {
                if (a.length) {
                    if (this.getUploadInfo(a[a.length - 1])) {
                        this.fileList = a;
                        this.fileList.forEach(item => {
                            item.name = item.fileName;
                        });
                    } else {
                        this.uploader.removeFile(a[a.length - 1]);
                    }
                }
            })
            .on('success', (a, b, c) => {
                this.successNum++;
                if (this.successNum === this.fileList.length) {
                    this.loading = false;
                    this.$emit('update:visible', false);
                    this.$emit('uploadSuccess', b);
                }
            }).on('error', (a, b, c) => {
                // this.$message.error(`上传文件失败，错误文件${b.name}`);
                this.loading = false;
            });
    },
    methods: {
        getUploadInfo(file) {
            // 不允许上传不可预览格式文件
            let uploadTypeReg =
                /\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga|doc|docx|xls|xlsx|ppt|pptx|pdf|txt)$/;
            let fileType = file.fileName.slice(file.fileName.lastIndexOf("."));

            if (!uploadTypeReg.test(fileType.toLowerCase())) {
                this.$message.warning("不支持上传" + fileType + "格式文件");
                return false;
            }
            if (file.size > OSS_FILE_MAX_SIZE * THOUSAND_TWENTY_FOUR * THOUSAND_TWENTY_FOUR) {
                this.$message.warning(`上传文件不能大于${OSS_FILE_MAX_SIZE}MB`);
                return false;
            }
            return true
        },
        submitUpload() {
            if (this.fileList.length === 0) {
                this.$message.warning('请上传文件');
            } else {
                this.loading = true;
                this.uploader.upload(null, true);
            }
        },
        handleRemove(row) {
            const index = this.fileList.indexOf(row);
            this.fileList.splice(index, 1);
            this.uploader.removeFile(row);
        },
        onchange(file, fileList) {
            this.fileList = fileList;
        },
        beforeColse() {
            this.fileList = [];
            this.$emit('update:visible', false); // 直接修改父组件的属性
        },
        onChooseFile() {
            this.uploader.chooseFile();
        }
    }

};
</script>
<style lang='less'>
.oss-more {
    display: inline-block;

    .upload-demo {
        display: flex;
        // display: inline-block;
        margin-right: 10px;
        margin-bottom: 10px;
        width: 100%;
    }
    .el-upload-list__item {float: left;margin-top:0;margin-left: 5px;width: 200px;}
    .el-upload-list__item-name{margin-right: 5px;}
    .btn{height: 100%;}
    .el-col{display: flex;}
}
</style>